import { render, staticRenderFns } from "./HistoriqueOrdonnance.vue?vue&type=template&id=2eb6e8ab&"
import script from "./HistoriqueOrdonnance.vue?vue&type=script&lang=js&"
export * from "./HistoriqueOrdonnance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports